jQuery(document).ready(function($) {

    fetch(woocommerce_params.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'get_cart_quantity'
        })
    })
    .then(response => response.text())
    .then(data => {
        const elementCount =  document.querySelector('.qte-cart-totals-count')
        elementCount.innerHTML = data;
        elementCount.style.display = 'flex';
        elementCount.style.justifyContent = 'center';
    })
    .catch(error => console.error('Fetch error:', error));



});
